export default __webpack_public_path__ + "static/tetiana-5423fb05e3bb2cf3410f27eb5a2594bb.jpg";